import React from 'react';
import api from '../api/client';

const FIELD_STYLE = { flexDirection: 'column', alignItems: 'flex-start', gap: 4 };
// Одна высота у списков и поля курса: иначе подписи в ряду стоят на разной высоте (Safari рисует select выше)
const control = width => ({ width, height: 36, boxSizing: 'border-box' });

/**
 * UploadOrderSettings
 * Валюта, курс, единица веса и Import order для загрузки заказа из файла — одни на весь файл.
 * Числа в файле читаются в выбранных единице и валюте, в lb и USD их пересчитывает сервер.
 *
 * Props:
 *   settings   { currency, fx_rate, weight_unit, is_import } — см. UPLOAD_SETTINGS в utils/orderUnits
 *   onChange   setState-функция (принимает updater)
 *   showUnit   показывать выбор единицы веса (семена)
 */
const UploadOrderSettings = ({ settings, onChange, showUnit = false }) => {
  const set = (patch) => onChange(prev => ({ ...prev, ...patch }));
  const isEUR = settings.currency === 'EUR';

  const handleCurrency = async (currency) => {
    set({ currency });
    if (currency !== 'EUR' || parseFloat(settings.fx_rate) > 0) return;
    // Подстановка курса ECB на сегодня; правится руками под курс инвойса
    try {
      const { data } = await api.get('/api/material-orders/fx-rate');
      onChange(prev => (parseFloat(prev.fx_rate) > 0 ? prev : { ...prev, fx_rate: String(data.rate) }));
    } catch (_) { /* источник недоступен — курс вводится вручную */ }
  };

  return (
    <div>
      <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', alignItems: 'flex-end' }}>
        <label className="upload-orders-field" style={FIELD_STYLE}>
          <span className="upload-orders-label">Currency</span>
          <select
            className="upload-orders-input"
            value={settings.currency}
            onChange={e => handleCurrency(e.target.value)}
            style={control(110)}
          >
            <option value="USD">USD</option>
            <option value="EUR">EUR</option>
          </select>
        </label>

        {isEUR && (
          <label className="upload-orders-field" style={FIELD_STYLE}>
            <span className="upload-orders-label">
              Rate EUR→USD <span style={{ color: '#ef4444' }}>*</span>
            </span>
            <input
              className="upload-orders-input"
              type="number"
              step="0.0001"
              min="0"
              placeholder="e.g. 1.1367"
              title="ECB rate for today is prefilled; edit if the invoice used another rate"
              value={settings.fx_rate}
              onChange={e => set({ fx_rate: e.target.value })}
              style={control(140)}
            />
          </label>
        )}

        {showUnit && (
          <label className="upload-orders-field" style={FIELD_STYLE}>
            <span className="upload-orders-label">Unit</span>
            <select
              className="upload-orders-input"
              value={settings.weight_unit}
              onChange={e => set({ weight_unit: e.target.value })}
              style={control(90)}
            >
              <option value="lb">lb</option>
              <option value="kg">kg</option>
            </select>
          </label>
        )}

        <label style={{
          display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer',
          fontSize: '0.95rem', fontWeight: 500, color: '#374151', paddingBottom: 8,
        }}>
          <input
            type="checkbox"
            checked={!!settings.is_import}
            onChange={e => set({ is_import: e.target.checked })}
          />
          Import order
        </label>
      </div>
      <div style={{ fontSize: '0.82rem', color: '#64748b', marginTop: 6 }}>
        <i className="fa-solid fa-circle-info" style={{ marginRight: 5 }}></i>
        Quantities and prices in the file are read in the selected {showUnit ? 'unit and currency' : 'currency'},
        as on the invoice. They are converted to {showUnit ? 'lb and USD' : 'USD'} on save.
        Duties{showUnit ? ' and Lab Testing' : ''} in the file are always in USD.
      </div>
    </div>
  );
};

export default UploadOrderSettings;
